import { AuthCallbackCognitoPage } from "@/features/auth/pages/AuthCallbackCognito";

const AuthCallbackCognito = () => {
  return <AuthCallbackCognitoPage />;
};

export default AuthCallbackCognito;
